module.exports = {
	"id": "EG",
	"name": "Egypt",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.061416,
			"5": 0.061416,
			"6": 0.03412,
			"7": null,
			"8": null,
			"9": 0.06824,
			"10": 0.006824,
			"11": 0.143304,
			"12": 0.081888,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.075064,
			"17": 0.116008,
			"18": 0.013648,
			"19": 0.853,
			"20": 0.156952,
			"21": 0.075064,
			"22": 0.027296,
			"23": 0.088712,
			"24": 2.415696,
			"25": 0.143304,
			"26": 0.23884,
			"27": 0.129656,
			"28": 0.197896,
			"29": 0.197896,
			"30": 1.003128,
			"31": 0.736992,
			"32": 0.532272,
			"33": 1.0236,
			"34": 0.627808,
			"35": 2.006256,
			"36": 0.470856,
			"37": 0.586864,
			"38": 0.293432,
			"39": 0.402616,
			"40": 0.388968,
			"41": 0.675576,
			"42": 0.771112,
			"43": 3.555304,
			"44": 1.494456,
			"45": 0.736992,
			"46": 0.313904,
			"47": 0.13648,
			"48": 0.1706,
			"49": 1.46716,
			"50": 0.088712,
			"51": 0.47768,
			"52": 0.382144,
			"53": 9.539952,
			"54": 2.886552,
			"55": 0.047768,
			"56": 0.020472,
			"57": null
		},
		"firefox": {
			"2": 0.805232,
			"3": 0.061416,
			"4": 0.06824,
			"5": 0.081888,
			"6": null,
			"7": 0.03412,
			"8": 0.06824,
			"9": 0.061416,
			"10": 0.047768,
			"11": 0.109184,
			"12": 0.095536,
			"13": 0.13648,
			"14": 0.040944,
			"15": 0.907592,
			"16": 0.10236,
			"17": 0.075064,
			"18": 0.88712,
			"19": 0.095536,
			"20": 0.10236,
			"21": 0.941712,
			"22": 0.095536,
			"23": 0.88712,
			"24": 0.129656,
			"25": 1.77424,
			"26": 0.232016,
			"27": 0.232016,
			"28": 0.286608,
			"29": 0.30708,
			"30": 0.320728,
			"31": 0.368496,
			"32": 0.218368,
			"33": 0.061416,
			"34": 0.10236,
			"35": 0.129656,
			"36": 0.191072,
			"37": 0.218368,
			"38": 0.27296,
			"39": 0.218368,
			"40": 0.232016,
			"41": 0.129656,
			"42": 0.03412,
			"43": 0.245664,
			"44": 0.095536,
			"45": 0.10236,
			"46": 0.10236,
			"47": 0.552744,
			"48": 0.518624,
			"49": 4.101224,
			"50": 0.320728,
			"51": null,
			"52": null,
			"3.5": 0.013648,
			"3.6": 0.184248
		},
		"opera": {
			"9": null,
			"11": 0.040944,
			"12": 0.006824,
			"15": 0.03412,
			"16": null,
			"17": 0.03412,
			"18": 0.03412,
			"19": 0.088712,
			"20": 0.116008,
			"21": 0.129656,
			"22": 0.088712,
			"23": 0.095536,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.06824,
			"29": 0.06824,
			"30": 0.095536,
			"31": 0.054592,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.061416,
			"37": 0.027296,
			"38": 0.03412,
			"39": 0.013648,
			"40": 0.40944,
			"41": 0.075064,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0.812056,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.06824,
			"12.1": 0.054592
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.798408,
			"6": 0.03412,
			"7": 0.040944,
			"8": 0.06824,
			"9": 0.03412,
			"10": 0.150128,
			"3.1": null,
			"3.2": null,
			"5.1": 0.013648,
			"6.1": null,
			"7.1": null,
			"9.1": 0.10236
		},
		"ios_saf": {
			"8": 0,
			"10": 1.58657737302,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0427564243339,
			"8.1-8.4": 0.078990682244,
			"9.0-9.2": 0.0376836282265,
			"9.3": 0.574916892173
		},
		"android": {
			"3": 0,
			"4": 0.0816639534884,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.010207994186,
			"4.1": 0.294573546512,
			"4.2-4.3": 0.736433866279,
			"4.4": 1.68869389535,
			"4.4.3-4.4.4": 1.70327674419
		},
		"ie": {
			"6": 0.0137966415842,
			"7": 0.0344916039604,
			"8": 2.3523273901,
			"9": 1.82115668911,
			"10": 1.80046172673,
			"11": 0.945069948515,
			"5.5": null
		},
		"op_mob": {
			"0": 0.114952109274,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0031931141465
		},
		"edge": {
			"12": 0.047768,
			"13": 0.10236,
			"14": 0.095536
		},
		"ie_mob": {
			"10": 0.0651098591549,
			"11": 0.265090140845
		},
		"bb": {
			"7": 0.0079375,
			"10": null
		},
		"samsung": {
			"0": 1.965325
		},
		"and_uc": {
			"0": 1.241425
		},
		"op_mini": {
			"0": 1.54872977658
		},
		"and_chr": {
			"0": 20.49346
		},
		"and_ff": {
			"0": 0.066675
		}
	},
	"total": 96.9989365
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/EG.json
 ** module id = 514
 ** module chunks = 0
 **/